import styles from "./SkipFilters.module.scss";
import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import classNames from "classnames";

export function SkipFilters() {
  return (
    <SecondaryButton
      data-testid="skip-filters-link"
      tag="a"
      href="#main-content"
      aria-label="Skip filters and jump to search results"
      className={classNames(styles.visuallyHidden, styles.visibleOnFocus)}
    >
      Skip Filters
    </SecondaryButton>
  );
}
